/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Cue_Come_CloserInputs */

const en_us2_body_assessment_cue_come_closer = /** @type {(inputs: Body_Assessment_Cue_Come_CloserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come a little closer.`)
};

const pt_br2_body_assessment_cue_come_closer = /** @type {(inputs: Body_Assessment_Cue_Come_CloserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproxime-se um pouco.`)
};

const es_419_body_assessment_cue_come_closer = /** @type {(inputs: Body_Assessment_Cue_Come_CloserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acércate un poco.`)
};

const pt_pt2_body_assessment_cue_come_closer = /** @type {(inputs: Body_Assessment_Cue_Come_CloserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproxima-te um pouco.`)
};

const fr_fr2_body_assessment_cue_come_closer = /** @type {(inputs: Body_Assessment_Cue_Come_CloserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapproche-toi un peu.`)
};

const de_de2_body_assessment_cue_come_closer = /** @type {(inputs: Body_Assessment_Cue_Come_CloserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komm etwas näher.`)
};

const it_it2_body_assessment_cue_come_closer = /** @type {(inputs: Body_Assessment_Cue_Come_CloserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvicinati un po'.`)
};

/**
* | output |
* | --- |
* | "Come a little closer." |
*
* @param {Body_Assessment_Cue_Come_CloserInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_cue_come_closer = /** @type {((inputs?: Body_Assessment_Cue_Come_CloserInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Cue_Come_CloserInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_cue_come_closer(inputs)
	if (locale === "es-419") return es_419_body_assessment_cue_come_closer(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_cue_come_closer(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_cue_come_closer(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_cue_come_closer(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_cue_come_closer(inputs)
	return en_us2_body_assessment_cue_come_closer(inputs)
});
export { body_assessment_cue_come_closer as "body-assessment.cue.come_closer" }